import { ApolloProvider } from '@apollo/react-hooks';
import { ReactComponent as SVGs } from '@do/walrus/icons.svg';
import '@do/walrus/style.css';
import { init } from '@sentry/browser';
import { Integrations } from '@sentry/tracing';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import client from './client';

if (
  process.env.NODE_ENV === 'production' &&
  process.env.REACT_APP_SENTRY_RELEASE
) {
  init({
    environment: process.env.NODE_ENV,
    release: process.env.REACT_APP_SENTRY_RELEASE,
    dsn: 'https://6edc8fb6c85e4294b525726a0698517f@sentry.io/1794139',
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 0.1,
    blacklistUrls: [
      // Chrome extensions
      /extension\//i,
      /^chrome:\/\//i,
      // pendo
      /data\.pendo\.io/i
    ],
    ignoreErrors: [/^Non-Error promise rejection captured with value:/]
  });
}

ReactDOM.render(
  <ApolloProvider client={client}>
    <App />
    <SVGs className="do-u-hidden" />
  </ApolloProvider>,
  document.getElementById('root')
);
